module.exports = __webpack_public_path__ + "static/media/Basisschool.fe3314ae.mp3";